import type { Directive } from "vue";

export default <Directive<HTMLElement, any>>{
  mounted: (el) => el.focus()
};
